/* src/app/modules/shared/components/layout/layout.component.scss */
.content {
  background-color: #a3c9ee;
}
.container1 {
  position: relative;
  width: 100%;
  max-width: 95%;
  height: 95%;
  margin: 0 auto;
  background-color: #073b70;
  border: 1px solid #d6d6d6;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 4px 6px rgba(243, 242, 242, 0.1);
}
.container1 .bg-white {
  height: 95%;
  overflow-y: auto;
  padding: 1rem;
}
.layout {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.layout app-topbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  z-index: 1050;
  background-color: #007bff;
  color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.layout .content {
  display: flex;
  flex: 1;
  margin-top: 60px;
  overflow-x: auto;
}
.layout app-sidebar {
  position: fixed;
  top: 60px;
  left: 0;
  width: 250px;
  height: calc(100vh - 60px);
  background-color: #073b70;
  color: #fff;
  z-index: 1040;
  overflow-y: auto;
  transition: width 0.3s ease;
}
.layout app-sidebar.collapsed {
  transform: translateX(-100%);
  visibility: hidden;
}
.layout app-sidebar.open {
  transform: translateX(-250px);
}
@media (max-width: 575.98px) {
  .container1,
  .container1 .bg-white {
    width: 100% !important;
    max-width: 100vw !important;
    overflow-x: visible !important;
    padding: 0.5rem !important;
    margin: 0;
  }
  .injected-content {
    margin: 0 !important;
  }
  .layout .content {
    flex-direction: column !important;
    width: 100vw !important;
    max-width: 100vw !important;
    overflow-x: hidden !important;
    margin-top: 60px;
  }
  app-sidebar {
    width: 200px !important;
    min-width: 0 !important;
    max-width: 200px !important;
    left: 0;
    top: 60px;
    height: calc(100vh - 60px);
    position: fixed;
    z-index: 2000;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s;
  }
  app-sidebar.collapsed {
    transform: translateX(-100%);
    visibility: hidden;
  }
}
/*# sourceMappingURL=layout.component.css.map */
